import { Injectable } from '@angular/core';

@Injectable()
export class AlertService {

  constructor() { }

  public alert(message : string){
    alert(message);
  }

  public alertError(error, defaultMessage="Unknown error"){
    console.log(JSON.stringify(error));
    
    let message = defaultMessage;
    if(error && error.friendlyMessage)
      message = error.friendlyMessage;
    else if(error && error.error && error.error.friendlyMessage)
      message = error.error.friendlyMessage;
      
    alert("Error: " + message);
  }
}
